// extracted by mini-css-extract-plugin
export default {"a11yHidden":"styles_a11yHidden__N+7Wq"};